import APSearchBar from './APSearchBar';

export { APSearchBar };

export default APSearchBar;
